import * as Redux from "redux";
import { IProcessVariable } from "../../processEditor/model/IProcessData";

export interface UpdateProcessVariablesAction extends Redux.Action {
    processId: number;
    processVariables: IProcessVariable[];
    agentGroupName: string;
}

export const UPDATE_PROCESS_VARIABLES = "UDPATE_PROCESS_VARIABLES";
export function updateProcessVariables(processId: number, processVariables: IProcessVariable[], agentGroupName: string): UpdateProcessVariablesAction {
    return {
        type: UPDATE_PROCESS_VARIABLES,
        processId: processId,
        processVariables: processVariables,
        agentGroupName: agentGroupName,
    };
}
